import axios from 'axios';
import _ from 'lodash';
import * as types from "./actionTypes";
import * as urls from './urlTypes';


import {
  toastError,
} from '../util/toastUtils';

import {
  SUPPORT_LEFT_NAV_ITEMS,
  TP_SUPPORT_LEFT_NAV_ITEMS,
} from '../constants';


export const fetchDocStudies = async(uid, accountId) => {
  const url = `${urls.ROOT_URL}/users/${uid}/${accountId}/doc-studies`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    if (response && response.data) {
      return response.data.data;
    }
    return false;
  } catch (error) {
    toastError('Study api failed');
    return false;
  }
}

export const getDocStudies = () => async (dispatch, getState) => {
  const { account, login } = getState();
  const { activeAccountId } = account;
  const { uid } = login.loginResponse.data;
  const studies = await fetchDocStudies(uid, activeAccountId);
  console.log(studies);
  dispatch({
    type: types.SET_DOC_STUDIES,
    studies
  });
}

export const setSupportNav = (parentNav, childNav = '') => (dispatch, getState) => {
  const activateNav = [];
  const { account } = getState();
  let NAV_ITEMS = SUPPORT_LEFT_NAV_ITEMS;
  if (account.isTPAccount) {
    NAV_ITEMS = TP_SUPPORT_LEFT_NAV_ITEMS;
  }
  NAV_ITEMS.map(parent => {
    const isParentActive = parent.name === parentNav;
    let activeChild = childNav;
    if (childNav) {
      activeChild = parent.children.includes(childNav) ? childNav : '';
    }
    const navigation = {
      ...parent,
      active: isParentActive,
      activeChild,
    };

    activateNav.push(navigation);
    return false;
  });

  dispatch({
    type: types.SET_SUPPORT_NAVIGATION,
    navItems: activateNav,
  });
};

const transformToTree = arr => {
  const nodes = {};
  return arr.filter(obj => {
    const id = obj.id;
    const parentId = obj.parent;

    nodes[id] = _.defaults(obj, nodes[id], {
      children: [],
    });
    if (parentId) {
      (nodes[parentId] = (nodes[parentId] || {
        children: [],
      })).children.push(obj);
    }
    return !parentId;
  });
};

const getNavItems = nav => {
  const sortedNav = _.cloneDeep(_.sortBy(nav, 'id'));
  const navigation = transformToTree(sortedNav);
  return navigation;
};

const getNavigation = (leftNavItems, isTPAccount = false) => {
  const allNavs = getNavItems(leftNavItems);
  let navItems = SUPPORT_LEFT_NAV_ITEMS;
  if (isTPAccount) {
    navItems = TP_SUPPORT_LEFT_NAV_ITEMS;
  }

  const updatedNav = {};

  _.map(navItems, item => {
    const individualNav = _.filter(allNavs, nav => nav.name === item.name);
    if (individualNav.length > 0) {
      updatedNav[item.name] = individualNav[0];
    }
  });
  return updatedNav;
};


export const getCategories = async isTPAccount => {
  const url = `${urls.API_GATEWAY_URL}/api/document-service/categories`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    if (response) {
      // setCategories();
      return getNavigation(response.data, isTPAccount);
    }
    return false;
  } catch (error) {
    toastError('Api failed to get Support Categories');
    return false;
  }
};


const getUserMedia = async categoryId => {
  const url = `${urls.API_GATEWAY_URL}/api/document-service/category/${categoryId}/media`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    if (response) {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get user guides');
    return false;
  }
};

const getDataWithFolder = (category, data, childCount) => {
  let mediaData = _.cloneDeep(data);
  const j = [];

  const makeTree = (parent, count, childCount) => {
    for (let i = 0; i < parent.children.length; i += 1) {
      makeTree(parent.children[i], count + 1, childCount);
    }

    const ar = mediaData.filter(item => item.categories.includes(parent.id));
    if (ar.length > 0) {
      const newData = {
        folder: count > childCount,
        files: ar,
        id: parent.id,
        name: parent.name,
        title: { name: parent.name },
        parent: parent.parent,
      };
      j.push(newData);
    }
    mediaData = mediaData.filter(item => !item.categories.includes(parent.id));
  };
  makeTree(category, 0, childCount);
  return j;
};

function reverse(arr) {
  return arr.length < 2 ? arr : [arr.pop()].concat(reverse(arr));
}

const sortRecursively = (data, sortFunction, direction) => {
  const sortedData = {
    ...data,
  };
  if (!_.isEmpty(data.files)) {
    if (direction === 'desc') {
      sortedData.files = reverse([...data.files].sort(sortFunction));
    } else {
      sortedData.files = [...data.files].sort(sortFunction);
    }
  }


  if (!_.isEmpty(data.folders)) {
    let folders = [];
    if (direction === 'desc') {
      folders = [...data.folders].sort(sortFunction).reverse();
    } else {
      folders = [...data.folders].sort(sortFunction);
    }
    sortedData.folders = folders.map(folder => sortRecursively(folder, sortFunction, direction));
  }
  return sortedData;
};

const generateUserGuideData = (category, data) => {
  const dataWithfolder = getDataWithFolder(category, data, 1);
  const allUserGuidesData = {
    title: {
      name: 'All User Guides',
    },
    id: 0,
    files: [],
    folders: [],
  };
  const userGuideCategoryData = [];
  _.map(dataWithfolder, item => {
    if (item.folder) {
      const folders = {
        id: item.id,
        title: item.title,
        files: [...allUserGuidesData.files, ...item.files],
      };
      allUserGuidesData.folders = [...allUserGuidesData.folders, folders];
    } else {
      allUserGuidesData.files = [...allUserGuidesData.files, ...item.files];
      userGuideCategoryData.push({
        id: item.id,
        title: item.title,
        files: item.files,
        folders: dataWithfolder.filter(ij => ij.parent === item.id),
      });
    }
  });

  const tabData = [allUserGuidesData, ...userGuideCategoryData];
  return tabData;
};

export const sortByName = (data, direction) =>
  sortRecursively(data, (a, b) => a.title.name.localeCompare(b.title.name), direction);

export const sortByDate = (data, direction) =>
  sortRecursively(data, (a, b) => {
    if (a.modified || b.modified) {
      return new Date(a.modified) - new Date(b.modified);
    }
    return new Date() - new Date();
  }, direction);

export const getUserGuides = async category => {
  const data = await getUserMedia(category.id);
  const userGuides = generateUserGuideData(category, data);
  const sortedData = [];
  _.map(userGuides, item => {
    sortedData.push(sortByDate(item, 'desc'));
  });
  return sortedData;
};


export const getReleases = async categoryId => {
  const url = `${urls.API_GATEWAY_URL}/api/document-service/category/${categoryId}/posts`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    if (response) {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get Releases');
    return false;
  }
};

const getUserMediaStudies = async (categoryId, studyId) => {
  const url = `${urls.API_GATEWAY_URL}/api/document-service/category/${categoryId}/media?study=${studyId}`;
  try {
    const response = await axios({
      url,
      method: 'get',
      responseType: 'json',
      withCredentials: true,
    });
    if (response) {
      return response.data;
    }
    return false;
  } catch (error) {
    toastError('Api failed to get user guides');
    return false;
  }
};


const generateStudyResourceData = (category, data) => {
  const dataWithfolder = getDataWithFolder(category, data, 0);
  const studyResources = {
    title: {
      name: category.name,
    },
    id: category.id,
    files: [],
    folders: [],
  };
  _.map(dataWithfolder, item => {
    if (item.folder) {
      const folders = {
        id: item.id,
        title: item.title,
        files: [...studyResources.files, ...item.files],
      };
      studyResources.folders = [...studyResources.folders, folders];
    } else {
      studyResources.files = [...studyResources.files, ...item.files];
    }
  });
  const tabData = [studyResources];
  return tabData;
};


export const getStudyResources = async (category, studyId) => {
  const data = await getUserMediaStudies(category.id, studyId);
  const updatedData = _.map(data, item => {
    let obj = item;
    if (!item.title || !item.title.name) {
      obj = {
        ...item,
        title: {
          name: item.name,
        },
      };
    }
    return obj;
  });
  const studyResources = generateStudyResourceData(category, updatedData);
  const sortedData = [];
  _.map(studyResources, item => {
    sortedData.push(sortByDate(item, 'desc'));
  });
  return { sortedData, actualData: studyResources };
};


export const getInsightsResources = async category => {
  const data = await getUserMedia(category.id);
  const updatedData = _.map(data, item => {
    let obj = item;
    if (!item.title || !item.title.name) {
      obj = {
        ...item,
        title: {
          name: item.name,
        },
      };
    }
    return obj;
  });
  const studyResources = generateStudyResourceData(category, updatedData);
  const sortedData = [];
  _.map(studyResources, item => {
    sortedData.push(sortByDate(item, 'desc'));
  });
  return sortedData;
};
